import { render } from "./CountBox.vue?vue&type=template&id=58b81ad0&scoped=true"
import script from "./CountBox.vue?vue&type=script&lang=js"
export * from "./CountBox.vue?vue&type=script&lang=js"

import "./CountBox.vue?vue&type=style&index=0&id=58b81ad0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b81ad0"]])

export default __exports__